import {
    AcademicProgramsApi,
    SubjectOffersApi,
    FormativeActionsApi,
    TransferAcademicRecordsApi,
    EnrollsApi, StudentAcademicProgramsTitleApi
} from "../_api/expedient/src";

import {
    CertificatesApi
} from "../_api/ilerna-StudentAccount/src";

import {asyncLazySingleton} from "../_common/common";

export const academicProgramsApi = new asyncLazySingleton(async ()=>{

    return new AcademicProgramsApi();
}) ;

export const formativeActionsApi = new asyncLazySingleton(async ()=>{

    return new FormativeActionsApi();
}) ;

export const subjectOffersApi = new asyncLazySingleton(async ()=>{

    return new SubjectOffersApi();
}) ;

export const transferAcademicRecordsApi = new asyncLazySingleton(async ()=>{

    return new TransferAcademicRecordsApi();
}) ;

export const enrollsPostponementApi = new asyncLazySingleton(async ()=>{

    return new EnrollsApi();
}) ;

export const studentAcademicProgramsTitleApi = new asyncLazySingleton(async ()=>{

    return new StudentAcademicProgramsTitleApi();
}) ;

export const certificatesApi = new asyncLazySingleton(async ()=>{
    
    return new CertificatesApi();
}) ;